import { render, staticRenderFns } from "./MyPromocodeModal.vue?vue&type=template&id=60c1d3e0&scoped=true"
import script from "./MyPromocodeModal.vue?vue&type=script&lang=ts"
export * from "./MyPromocodeModal.vue?vue&type=script&lang=ts"
import style0 from "./MyPromocodeModal.vue?vue&type=style&index=0&id=60c1d3e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c1d3e0",
  null
  
)

export default component.exports